// @flow
import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Dropdown } from 'react-bootstrap';
import SimpleBar from 'simplebar-react';
import { DEV_URL, rpost } from "utils/requests";
import NotificationsIcon from '@enerex/unified-ui-react/icons/NotificationsIcon';
import SuccessIcon from '@enerex/unified-ui-react/icons/SuccessIcon';
// notifiaction continer styles
const notificationContainerStyle = {
    maxHeight: '70vh',
    display: 'none',
};

const notificationShowContainerStyle = {
    maxHeight: '70vh',
};

type NotificationItem = {
    id: number,
    text: string,
    subText: string,
    icon: string,
    bgColor: string,
    notificationObject: any,
};

type NotificationDropdownProps = {
    notifications: Array<NotificationItem>,
    isReaded:Boolean,
    onOpen:any
};

type NotificationDropdownState = {
    dropdownOpen?: boolean,
    notificationContainerStyle?: {},
};

const NotificationDropdown = (
    props: NotificationDropdownProps,
    state: NotificationDropdownState
): React$Element<any> => {
    
const navigate = useNavigate();
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [notificationContentStyle, setNotificationContentStyles] = useState(notificationContainerStyle);
    const newArive = props.isReaded;

    const toggleDropdown = () => {
        setDropdownOpen(!dropdownOpen);
        setNotificationContentStyles(
            notificationContentStyle === notificationContainerStyle
                ? notificationShowContainerStyle
                : notificationContainerStyle
        );
    };
    

    /*
     * get redirect url for notification items
     */

    const getRedirectUrl = (item) => {
        return`/notifications?content=${item.id}`;
    };

    const removeNotification = async (index)=>{
        if(index>=0){
            props.notifications.splice(index,1);
        }else{
            props.notifications.splice(0,props.notifications.length);
        }
    }
   const markAllRead =async ()=>{
    var payload = {id:null,isRead:true,isAll:true };
                    const response = await rpost(`${DEV_URL}/api/Notification/Mark`,payload);
        if(response?.data!=null){
            if(response?.data==true){
                if(window.location.href.includes('/notifications')){
                    navigate(window.location.pathname + '?ReadAll=true', { replace: true });
                }
            }
        }
   }

   useEffect(()=>{
    if(dropdownOpen && props.notifications.length>0){
        markAllRead();
        props.onOpen();
    }
    
   },[dropdownOpen])
    return (
        <Dropdown show={dropdownOpen} onToggle={toggleDropdown}>
            <Dropdown.Toggle
                variant="link"
                id="dropdown-notification"
                as={Link}
                to="#"
                onClick={toggleDropdown}
                className="nav-link dropdown-toggle arrow-none">
                <NotificationsIcon className="noti-icon" fontSize={20} style={{ padding: 5 }} />
                {
                    newArive && <span className="noti-icon-badge"></span>
                }
                
            </Dropdown.Toggle>
            <Dropdown.Menu className="dropdown-menu dropdown-menu dropdown-menu-animated dropdown-lg">
                <div onClick={toggleDropdown}>
                    <div className="noti-title">
                        <h5 className="m-0">
                            {/* <span className="float-end">
                                <Link to="/notifications?readAll=true" onClick={()=>{removeNotification(null,0)}} className="text-dark">
                                   <small>Clear All</small>
                                </Link>
                            </span> */}
                            Notifications
                        </h5>
                    </div>
                    <SimpleBar style={notificationContentStyle}>
                        { props.notifications.length>0? props.notifications.map((item, i) => {
                            return (
                                <Link to="/notifications" onClick={()=>{removeNotification(-1)}} className="dropdown-item notify-item" key={i + '-noti'}>
                                    <div className={`notify-icon`}>
                                        <SuccessIcon style={{ color: 'green' }} />
                                    </div>
                                    <h6>{item.title}</h6>
                                    <p className="notify-details">{item.text}</p>
                                    <p className="text-muted mb-0 user-msg">
                                        
                                    </p>
                                </Link>
                            );
                        }):<div>
                            <p className="text-center">No New Notification</p>
                            </div>}
                    </SimpleBar>
                    <Link to="/notifications"  onClick={()=>{removeNotification(-1)}} className="dropdown-item text-center text-primary notify-item notify-all">
                        View All
                    </Link>
                </div>
            </Dropdown.Menu>
        </Dropdown>
    );
};

export default NotificationDropdown;
